import { useMemo } from "react";
/**
 * useHasReleaseDate
 *
 * Returns true if we have a reelease date
 *
 * @param {SelectedReviews} selectedReviews - The url of the service
 * @returns {boolean} true if reviews have a release date
 *
 */
const useHasReleaseDate = (selectedReviews) => useMemo(() => Object.values(selectedReviews).some((selectedReview) => Boolean(selectedReview.review.releaseDate)), [selectedReviews]);
export default useHasReleaseDate;
